import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-headermain',
    templateUrl: './headermain.component.html',
    styleUrls: ['./headermain.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeadermainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
